import { t as tt } from 'i18next'
import type * as Api from 'src/api'
import { useTranslatable } from 'src/hooks/locale/utils'
import * as Table from 'src/tailwind/components/Table'

/** A wrong column (e.g. personal numbers) skips every row, up to 20 000; the reasons repeat, so a sample is enough. */
const SHOWN_ROWS = 100

interface Props {
  readonly rows: readonly Api.AdministratorBulkMessageUnmatchedRow[]
}

export default function SkippedRows({ rows }: Props): JSX.Element {
  const t = useTranslatable()
  const hiddenCount = rows.length - SHOWN_ROWS

  return (
    <div data-testid="SkippedRows">
      <div className="mb-3 font-bold text-primaryTextColor">
        {t('bulk_message:skipped_rows')} ({rows.length})
      </div>
      <Table.Table>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>{t('bulk_message:row')}</Table.Th>
            <Table.Th>{t('bulk_message:user_id')}</Table.Th>
            <Table.Th>{t('bulk_message:reason')}</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {rows.slice(0, SHOWN_ROWS).map((row) => (
            <Table.Tr key={row.row}>
              <Table.Td>{row.row}</Table.Td>
              <Table.Td>{row.value}</Table.Td>
              <Table.Td>{row.reason}</Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table.Table>
      {hiddenCount > 0 && (
        <p className="mt-2 text-sm text-captionColor">{tt('bulk_message:more_skipped_rows', { count: hiddenCount })}</p>
      )}
    </div>
  )
}
